import { Controller } from "@hotwired/stimulus"
import L from "leaflet"

export default class extends Controller {
  static values = { latitude: Number, longitude: Number, title: String }

  connect() {
    this.map = L.map(this.element, { scrollWheelZoom: false }).setView(
      [this.latitudeValue, this.longitudeValue], 16
    )
    L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", {
      attribution: '&copy; <a href="https://carto.com/attributions">CARTO</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map)
    L.marker([this.latitudeValue, this.longitudeValue]).addTo(this.map).bindPopup(this.titleValue).openPopup()
  }

  disconnect() {
    this.map?.remove()
  }
}
